"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PageController = function PageController() {
  _classCallCheck(this, PageController);

  this.body = document.getElementsByTagName("body")[0];
  this.header = document.getElementsByTagName("header")[0];
  this.footer = document.getElementsByTagName("footer")[0];
  this.content = document.getElementsByTagName("main")[0];
  this.template = $('body').data('template'); //this.mobileMenu = new MobileMenu();

  this.flashMessage = new FlashMessage();
  this.arrayUtils = new ArrayUtils();
  this.dateUtils = new DateUtils();
  this.numberUtils = new NumberUtils();
  this.stringUtils = new StringUtils();
  this.footerLayout = new FooterComponent(this.header, this.footer, this.content);
  $('.guide-icon').webuiPopover({
    title: 'Title',
    content: 'Content',
    placement: 'auto'
  });
};